import React from 'react'

import { ColumnProps } from 'antd/lib/table'

import { ReimbursementBalanceItem } from 'core/application/adminDashboard/reimbursements/perks/reimbursementsBalances/getReimbursementsBalances'
import OrderedPageFilter from 'core/application/commons/orderedPageFilter'

import { formatMoney } from 'common/moneyFormatter'

export const reimbursementsBalancesColumns = (
  translate: (key: string) => string,
  filter: OrderedPageFilter,
): ColumnProps<ReimbursementBalanceItem>[] => {
  const columns: ColumnProps<ReimbursementBalanceItem>[] = [
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-balances.full-name-label'),
      dataIndex: 'fullName',
      key: 'fullName',
      align: 'left',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-balances.perks-name-label'),
      dataIndex: 'categoryName',
      key: 'categoryName',
      align: 'right',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      render: (item: number) => {
        return item
      },
    },
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-balances.ytd-allowance-label'),
      dataIndex: 'allowanceYTD',
      key: 'allowanceYTD',
      align: 'right',
      render: (item: number) => {
        return formatMoney(item)
      },
    },
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-balances.ytd-reimbursements-label'),
      dataIndex: 'reimbursementYTD',
      key: 'reimbursementYTD',
      align: 'right',
      render: (item: number) => {
        return formatMoney(item)
      },
    },
    {
      title: translate('admin-dashboard.reimbursements.reimbursements-balances.balance-label'),
      dataIndex: 'balance',
      key: 'balance',
      align: 'right',
      render: (item: number) => {
        return <span className={item < 0 ? 'color-red-6' : ''}>{formatMoney(item)}</span>
      },
    },
  ]

  const columnToSort: any = columns.find((c) => c.key === filter.orderColumn)
  columnToSort.defaultSortOrder = filter.orderDescending ? 'descend' : 'ascend'

  return columns
}
